export default function HowToUse() {
  const steps = [
    {
      number: '01',
      title: 'フレーバーを詰める',
      description: 'お好みのシーシャフレーバーをボウルに均一に詰めます。詰めすぎず、空気が通るよう軽くほぐしながら入れるのがポイントです。Spring Sun Bowlは18g以上詰めてください。当店では18gと24gの2つを選択してもらっています。物量は正義です！シーシャは入れれば入れるだけ美味しい味を提供してくれます。※写真は24gのフレーバを詰めています。',
      icon: 'ri-bowl-line',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/904300316c4f998c2e6e97b5562cf3c4.png'
    },
    {
      number: '02',
      title: 'アルミを巻いて穴を開ける',
      description: 'アルミを巻いて穴を開けてください。ポイントは全体に穴を均等に開けてください。理由は炭がバウンドして動くのを防ぐ為です。',
      icon: 'ri-leaf-line',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/f2d501625b5d1f948d628a4aede9ce87.png'
    },
    {
      number: '03',
      title: '炭を三ツ矢に置いて２回吸う',
      description: 'ボウルの上にアルミホイルをしっかりと張り、爪楊枝や専用ツールで均等に穴を開けます。穴の数と配置が煙の質を左右します。',
      icon: 'ri-scissors-cut-line',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/9c8731ead1e949a9fa7c6703b323df3b.png'
    },
    {
      number: '04',
      title: 'メンテナンス',
      description: '50分立ったら炭を真ん中に寄せてあたらしい炭を焼き始めてください。第一世代は炭変えはT字に配置してください。第二世代は三ツ矢で少し外に逃して配置してください。※写真は第一世代の配置方法です。',
      icon: 'ri-tools-line',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/147b682e6518f57d6f2d56644ed86653.png'
    },
  ];

  return (
    <section id="how-to-use" className="py-24 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-bold text-gray-900">使用方法</h2>
          <p className="text-gray-500 mt-4 text-xl">Spring Sun Bowlで最高のシーシャ体験を</p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-10 group`}
            >
              <div className="w-full lg:w-2/5 flex-shrink-0">
                <div className="rounded-3xl overflow-hidden shadow-xl aspect-square">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>

              <div className="w-full lg:w-3/5">
                <div className="flex items-start gap-6">
                  <span className="text-8xl font-bold text-amber-200 leading-none select-none">{step.number}</span>
                  <div className="pt-2">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full">
                        <i className={`${step.icon} text-2xl text-amber-600`}></i>
                      </div>
                      <h3 className="text-3xl font-bold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600 text-xl leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-3xl p-8 shadow-md flex items-start gap-6">
          <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
            <i className="ri-lightbulb-line text-2xl text-amber-600"></i>
          </div>
          <div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">ワンポイントアドバイス</h4>
            <p className="text-gray-600 text-lg leading-relaxed">
              この立ち上げ方は家シーシャを怠惰に立ち上げるための方法です。<br />
              当店ではもう少し細かく炭をメンテナンスしています。<br />
              興味があったらぜひご来店のほどよろしくお願い申し上げます。
            </p>
          </div>
        </div>

        <div className="mt-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
              <i className="ri-play-circle-line text-2xl text-amber-600"></i>
            </div>
            <h4 className="text-2xl font-bold text-gray-900">動画で見る</h4>
          </div>
          <div className="rounded-3xl overflow-hidden bg-black" style={{ aspectRatio: '16/9' }}>
            <iframe
              src="https://www.youtube.com/embed/dEBCZv8T3MQ"
              title="Spring Sun Bowl 使用方法"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="w-full h-full"
              style={{ border: 'none' }}
            ></iframe>
          </div>
        </div>

      </div>
    </section>
  );
}
